import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/home.vue'
import login from '../views/app.login.vue'
import signup from '../views/app.signup.vue'
import passwordChange from '../views/app.password.change.vue'
import passwordrecovery from '../views/app.password.recovery.vue'
import connection from '../views/app.connection.vue'

import BazaDai from '../views/BazaDai'
import CarPlates from '../views/CarPlates'
import VehicleEstimate from '../views/vehicle.estimate.vue'

import Organizations from '../views/Organizations'
import Roles from '../views/Roles'
import Services from '../views/Services'
import Users from '../views/Users'

import Document from '../views/Document'

import Estimate from '../views/Estimate'
import EstimateAveragePrice from '../views/EstimateAveragePrice'

import NbuFinancialInstitution from '../views/NbuFinancialInstitution.vue'
import NbuInsuranceIntermediary from '../views/NbuInsuranceIntermediary.vue'

import Tariff from '../views/Tariff'

import RealtyAveragePrice from '@/views/RealtyAveragePrice'
import RealtyRequest from '@/views/RealtyRequest'

import Report from '../views/Report'
import ReportVehicleMarketValue from '../views/report/VehicleMarketValue'
import ReportVehicleRequestCount from '../views/report/VehicleRequestCount'
import ReportVehicleRequestTypeCount from '../views/report/VehicleRequestTypeCount'
import ReportVehicleRequestTypeUserOrganisationCount from '../views/report/VehicleRequestTypeUserOrganisationCount'
import ReportVehicleRequestBrandModelCount from '../views/report/VehicleRequestBrandModelCount'
import ReportVehicleRequestBrandYearAvgPrice from '../views/report/VehicleRequestBrandYearAvgPrice'
import ReportVehicleRequestIdentification from '../views/report/VehicleRequestIdentification'
import ReportVehicleRequestDetail from '../views/report/VehicleRequestDetail'
import ReportVehicleRequestList from '../views/report/VehicleRequestList'
import ReportVehicleRequestOrganisationCount from '../views/report/VehicleRequestOrganisationCount'
import ReportVehicleRequestOrganisationMonthly from '../views/report/VehicleRequestOrganisationMonthly'
import ReportVehicleRequestOrganisationTypeCount from '../views/report/VehicleRequestOrganisationTypeCount'
import ReportVehicleVinDecoding from '../views/report/VehicleVinDecoding'

import VehicleAssessment from '@/views/VehicleAssessment'
import VehicleAutoParams from '@/views/VehicleAutoParams'
import VehicleAutoAdvert from '@/views/VehicleAutoAdvert'
import VehicleAutoAdvertFotos from '@/views/VehicleAutoAdvertFotos'
import VehicleAveragePrice from '@/views/VehicleAveragePrice'
import VehicleAveragePriceAI from '@/views/VehicleAveragePriceAI'
import VehicleAveragePriceCombo from '@/views/VehicleAveragePriceCombo'
import VehicleAveragePriceMediana from '@/views/VehicleAveragePriceMediana'
import VehicleAveragePriceShowroom from '@/views/VehicleAveragePriceShowroom'
import VehicleAveragePriceStatistic from '@/views/VehicleAveragePriceStatistic'
import VehicleBrandModel from '@/views/VehicleBrandModel'

//import VehicleEstimateCheck from '../views/VehicleEstimateCheck'
import VehicleEquipment from '@/views/VehicleEquipment'
import VehicleEstimateAI from '../views/VehicleEstimateAI'
import VehicleEstimateIdentify from '../views/VehicleEstimateIdentify'
import VehicleEstimateMarket from '../views/VehicleEstimateMarket'
import VehicleEstimateExpress from '../views/VehicleEstimateExpress'
import VehicleEstimateMetodica from '../views/VehicleEstimateMetodica'
import VehicleEstimateExploration from '../views/VehicleEstimateExploration'
import VehicleInspectionAct from '../views/VehicleInspectionAct'
import VehicleInspectionAI from '../views/VehicleInspectionAI'
import VehiclePark from '@/views/VehiclePark'
import VehicleRequest from '@/views/VehicleRequest'

import VehicleVerifyVin from '@/views/VehicleVerifyVin'

import OrganizationStatistic from '@/views/OrganizationStatistic'

import CatalogVehicle from '@/views/CatalogVehicle'
import CatalogVehicleEstimate from '@/views/CatalogVehicleEstimate'

import DialogTable from '@/views/components/dialog.table'

Vue.use(VueRouter) 
const routes = [
	//{ path: '*', component: NotFoundComponent },
	{ path: '/', name: 'home', component: home },
	{ path: '/login', name: 'login', component: login },
	{ path: '/signup', name: 'signup', component: signup },
	{ path: '/password/change', name: 'passwordChange', component: passwordChange },
	{ path: '/password/recovery', name: 'passwordrecovery', component: passwordrecovery },
	{ path: '/connection', name: 'connection', component: connection },

	{ path: '/nbu/financia/institution', 				name: 'NbuFinancialInstitution', 		component: NbuFinancialInstitution },
	{ path: '/nbu/insurance/intermediary', 				name: 'NbuInsuranceIntermediary', 		component: NbuInsuranceIntermediary },

	{ path: '/tariff',         							name: 'Tariff',							component: Tariff },
	
	{ path: '/report',         							name: 'Report',							component: Report },
	{ path: '/report/VehicleMarketValue',				name: 'ReportVehicleMarketValue',		component: ReportVehicleMarketValue, props: true },
	{ path: '/report/VehicleRequestBrandModelCount',	name: 'ReportVehicleRequestBrandModelCount',		component: ReportVehicleRequestBrandModelCount, props: true },
	{ path: '/report/VehicleRequestBrandYearAvgPrice',	name: 'ReportVehicleRequestBrandYearAvgPrice',		component: ReportVehicleRequestBrandYearAvgPrice, props: true },
	{ path: '/report/VehicleRequestCount',         		name: 'ReportVehicleRequestCount',		component: ReportVehicleRequestCount, props: true },
	{ path: '/report/VehicleRequestDetail',				name: 'ReportVehicleRequestDetail',		component: ReportVehicleRequestDetail, props: true },
	{ path: '/report/VehicleRequestIdentification',		name: 'ReportVehicleRequestIdentification',		component: ReportVehicleRequestIdentification, props: true },
	{ path: '/report/VehicleRequestList',				name: 'ReportVehicleRequestList',		component: ReportVehicleRequestList, props: true },
	{ path: '/report/VehicleRequestOrganisationCount',	name: 'ReportVehicleRequestOrganisationCount',		component: ReportVehicleRequestOrganisationCount, props: true },
	{ path: '/report/VehicleRequestOrganisationMonthly',	name: 'ReportVehicleRequestOrganisationMonthly',		component: ReportVehicleRequestOrganisationMonthly, props: true },
	{ path: '/report/VehicleRequestOrganisationTypeCount',	name: 'ReportVehicleRequestOrganisationTypeCount',		component: ReportVehicleRequestOrganisationTypeCount, props: true },
	{ path: '/report/VehicleRequestTypeCount',         	name: 'ReportVehicleRequestTypeCount',	component: ReportVehicleRequestTypeCount, props: true },
	{ path: '/report/VehicleRequestTypeUserOrganisationCount',         	name: 'ReportVehicleRequestTypeUserOrganisationCount',		component: ReportVehicleRequestTypeUserOrganisationCount, props: true },
	{ path: '/report/VehicleVinDecoding',         		name: 'ReportVehicleVinDecoding',		component: ReportVehicleVinDecoding, props: true },
	
	//{ path: '/vehicle/estimate/check',         		name: 'VehicleEstimateCheck',			component: VehicleEstimate, props: { type: 'check', title: 'Ідентифікація транспортного засобу' } },
	//{ path: '/vehicle/estimate/check',         		name: 'VehicleEstimateCheck',			component: VehicleEstimateCheck },
	{ path: '/vehicle/estimate/ai',         			name: 'VehicleEstimateAI',				component: VehicleEstimateAI },
	{ path: '/vehicle/estimate/identify',         		name: 'VehicleEstimateIdentify',		component: VehicleEstimateIdentify },
	//{ path: '/vehicle/estimate/market',         		name: 'VehicleEstimateMarket',			component: VehicleEstimate, props: { type: 'market', title: 'Аналіз ринкових цін транспортного засобу' } },
	{ path: '/vehicle/estimate/express',         		name: 'VehicleEstimateExpress',			component: VehicleEstimateExpress },
	{ path: '/vehicle/estimate/market',         		name: 'VehicleEstimateMarket',			component: VehicleEstimateMarket },
	//{ path: '/vehicle/estimate/metodica',       		name: 'VehicleEstimateMetodica', 		component: VehicleEstimate, props: { type: 'metodica', title: 'Оцінка ринкової вартості транспортного засобу' } },
	{ path: '/vehicle/estimate/metodica',       		name: 'VehicleEstimateMetodica', 		component: VehicleEstimateMetodica, props: { type: 'metodica', title: 'Оцінка ринкової вартості транспортного засобу' } },
	//{ path: '/vehicle/estimate/exploration',    		name: 'VehicleEstimateExploration',		component: VehicleEstimate, props: { type: 'exploration', title: 'Автотоварознавче дослідження транспортного засобу' } },
	{ path: '/vehicle/estimate/exploration',    		name: 'VehicleEstimateExploration',		component: VehicleEstimateExploration, props: { type: 'exploration', title: 'Автотоварознавче дослідження транспортного засобу' } },
	{ path: '/vehicle/inspection/act',    				name: 'VehicleInspectionAct',			component: VehicleInspectionAct },
	{ path: '/vehicle/inspection/ai',    				name: 'VehicleInspectionAI',			component: VehicleInspectionAI },
	
	{ path: '/vehicle/assessment',   					name: 'VehicleAssessment',				component: VehicleAssessment },
	{ path: '/vehicle/brandmodel',   					name: 'VehicleBrandModel',				component: VehicleBrandModel },
	{ path: '/vehicle/estimate/auto/params',   			name: 'VehicleAutoParams',				component: VehicleAutoParams },
	{ path: '/vehicle/estimate/auto/advert',   			name: 'VehicleAutoAdvert',				component: VehicleAutoAdvert },
	{ path: '/vehicle/estimate/auto/advert/fotos',   	name: 'VehicleAutoAdvertFotos',			component: VehicleAutoAdvertFotos },
	{ path: '/vehicle/estimate/averageprice',   		name: 'VehicleAveragePrice',			component: VehicleAveragePrice },
	{ path: '/vehicle/estimate/averageprice/ai',   		name: 'VehicleAveragePriceAI',			component: VehicleAveragePriceAI },
	{ path: '/vehicle/estimate/averageprice/combo',   	name: 'VehicleAveragePriceCombo',		component: VehicleAveragePriceCombo },
	{ path: '/vehicle/estimate/averageprice/mediana',	name: 'VehicleAveragePriceMediana',		component: VehicleAveragePriceMediana },
	{ path: '/vehicle/estimate/averageprice/showroom',	name: 'VehicleAveragePriceShowroom',	component: VehicleAveragePriceShowroom },
	{ path: '/vehicle/estimate/averageprice/statistic',	name: 'VehicleAveragePriceStatistic',	component: VehicleAveragePriceStatistic },
	{ path: '/vehicle/estimate/equipment',   			name: 'VehicleEquipment',				component: VehicleEquipment },
	{ path: '/vehicle/park',   							name: 'VehiclePark',					component: VehiclePark },
	{ path: '/vehicle/verify/vin',   					name: 'VehicleVerifyVIN',				component: VehicleVerifyVin },
	{ path: '/drug/estimate/market',            		name: 'DrugEstimateMarket',				component: VehicleEstimate, props: { type: 'market', title: 'Аналіз ринкових цін лікарських засобів' } },
	{ path: '/realty/estimate/averageprice',			name: 'RealtyAveragePrice',				component: RealtyAveragePrice },
	
	{ path: '/document',            					name: 'Document',						component: Document },

	{ path: '/estimate',            					name: 'Estimate',						component: Estimate },
	{ path: '/estimate/drug/averageprice',            	name: 'DrugAveragePrice',				component: EstimateAveragePrice, props: { type: 'DrugAveragePrice', title: 'Середня ціна ЛЗ', subtitle: 'Визначення середньої ціни лікарських засобів' } },

	{ path: '/roles',            						name: 'Roles',							component: Roles },
	{ path: '/services',            					name: 'Services',						component: Services },
	{ path: '/users',            						name: 'Users',							component: Users },
	{ path: '/organizations',            				name: 'Organizations',					component: Organizations },
	{ path: '/vehicle/requests',   						name: 'VehicleRequest',					component: VehicleRequest, props: { own: false } },
	{ path: '/vehicle/myrequests',   					name: 'VehicleMyRequest',				component: VehicleRequest, props: { own: true } },
	{ path: '/organization/statistic',   				name: 'OrganizationStatistic',			component: OrganizationStatistic },
	{ path: '/realty/requests',   						name: 'RealtyRequest',					component: RealtyRequest, props: { own: false } },
	{ path: '/bazadai',   								name: 'BazaDai',						component: BazaDai },
	{ path: '/carplates',   							name: 'CarPlates',						component: CarPlates },

	{ path: '/catalog/vehicle',   						name: 'CatalogVehicle',					component: CatalogVehicle },
	{ path: '/catalog/vehicle/estimate',   				name: 'CatalogVehicleEstimate',			component: CatalogVehicleEstimate },
	
	
	/* {
		path: '/about',
		name: 'about',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import('../views/About.vue')
	}, */
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,

	scrollBehavior (to, from, savedPosition) {
		if (to.hash) {
			return {
				selector: to.hash
			}
		}
	}
})

export default router
